import React from "react";
import ApprovedVideoIcon from "../../public/assets/icons/ApprovedVideoIcon";
import RejectedVideoIcon from "../../public/assets/icons/RejectedVideoIcon";
import { List, ListItem, Typography } from "@mui/material";
import styels from "../../styles/components/qcreviewdvideosmenu.module.scss";
import { Box } from "@mui/system";
import WebsiteIconTwo from "../../public/assets/icons/WebsiteIconTwo";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useNavigate } from "react-router";
import { Link, useLocation } from "react-router-dom";

export const QCReviewdVideosMenu = () => {
  const { qcSubmisson } = useAppSelector((s) => s.appStateSlice);
  //   console.warn("qcSubmisson", qcSubmisson);

  const menuItems = [
    {
      icon: (
        <>
          <ApprovedVideoIcon />
        </>
      ),
      text: "Approved Videos",
      number: qcSubmisson?.reviewed_videos?.approved,
      route: "/qcagent-dashboard/reviewed-videos/approved",
    },
    {
      icon: (
        <>
          <WebsiteIconTwo />
        </>
      ),
      text: "Website Only",
      number: qcSubmisson?.reviewed_videos?.website_only,
      route: "/qcagent-dashboard/reviewed-videos/website-only",
    },
    {
      icon: (
        <>
          <RejectedVideoIcon />
        </>
      ),
      text: "Rejected Videos",
      number: qcSubmisson?.reviewed_videos?.rejected,
      route: "/qcagent-dashboard/reviewed-videos/rejected",
    },
  ];

  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <List className={styels.video_nav} disablePadding>
      {menuItems.map((item, index) => (
        <ListItem
          onClick={() => navigate(item.route)}
          key={index}
          disablePadding
        >
          <Link
            to={item.route}
            className={pathname == item.route ? `${styels.active}` : ""}
          >
            <Typography variant="caption" className={styels.icon}>
              {item.icon}
            </Typography>
            <Box className={styels.menu_rght}>
              <Typography variant="body2">{item.text}</Typography>
              <Typography variant="caption">{item.number}</Typography>
            </Box>
          </Link>
        </ListItem>
      ))}
    </List>
  );
};
